import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import axiosClient from "api/index.js";

// Landing page for the "Unsubscribe from these reminders" link in the profile
// reminder emails. The link points here (the app), and this page calls the
// backend with the signed token from the query string.
const UnsubscribeReminders = () => {
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");

    if (!token) {
      setStatus("error");
      setMessage(
        "This unsubscribe link is missing its token. Please use the link from the email, or contact support and we'll take care of it."
      );
      return;
    }

    axiosClient
      .get("/public/unsubscribe-reminders", { params: { token } })
      .then(() => {
        setStatus("success");
      })
      .catch((err) => {
        console.error(err);
        setStatus("error");
        setMessage(
          err?.response?.data?.message ||
            "We couldn't process your request. Please contact support and we'll take care of it."
        );
      });
  }, [location.search]);

  return (
    <main className="flex-1 flex items-center justify-center px-[20px] py-[80px]">
      <div className="w-full max-w-[560px] bg-[#F9F9F9] rounded-[20px] p-[45px] text-center">
        {status === "loading" && (
          <>
            <h2 className="mb-3">One moment…</h2>
            <p className="text-[15px] text-[#6b7280]">
              We're updating your email preferences.
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <h2 className="mb-3">You've been unsubscribed</h2>
            <p className="text-[15px] text-[#6b7280] mb-6">
              You won't receive any more profile reminder emails from us. You
              can still use your account as normal, and we'll still send you
              important emails about your services and requests.
            </p>
            <Link
              to="/"
              className="!text-white inline-block py-3 px-8 !bg-second !border-second capitalize rounded-full transition-all duration-300 hover:!bg-main hover:!border-main"
            >
              Go to TRADEITFWD
            </Link>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="mb-3">This link isn't valid</h2>
            <p className="text-[15px] text-[#6b7280] mb-6">{message}</p>
            <Link
              to="/contact-us"
              className="!text-white inline-block py-3 px-8 !bg-second !border-second capitalize rounded-full transition-all duration-300 hover:!bg-main hover:!border-main"
            >
              Contact support
            </Link>
          </>
        )}
      </div>
    </main>
  );
};

export default UnsubscribeReminders;
